export default function ExpertiseSection() {
  const expertiseAreas = [
    {
      icon: 'ri-user-heart-line',
      title: 'Legal Services',
      description: `Professional consultancy in law and policy development, legal drafting, compliance reviews, advocacy support, and legal advice and strategic guidance for complex legal matters.`,
    },
    {
      icon: 'ri-government-line',
      title: 'Public Law & Governance',
      description: `Advisory on public and private sector governance frameworks, institutional reform, and the legal dimensions of public policy design, implementation and intersection with the private sector and civil society.`,
    },
    {
      icon: 'ri-file-paper-2-line',
      title: 'Contract Law',
      description: `Expert guidance on contract formation, interpretation, and enforcement; drafting and reviewing commercial agreements; identifying contractual risks; and resolving disputes arising from contractual obligations.`,
    },
    {
      icon: 'ri-plant-line',
      title: 'Natural Resources Management',
      description: `In-depth knowledge of natural resources law and policy, including Wildlife Economy frameworks, Community-Based Natural Resources Management (CBNRM), conservation governance, land use rights, and the legal structures underpinning sustainable resource utilisation and community benefit-sharing arrangements.`,
    },
    {
      icon: 'ri-building-4-line',
      title: 'Organizations & Compliance Advisory',
      description: `Comprehensive support for corporate governance, regulatory compliance, and institutional structuring. We assist private companies, NGOs, and public entities in developing internal compliance frameworks, governance policies, and risk management strategies aligned with applicable laws and best practices.`,
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Dispute Resolution & Mediation',
      description: `Skilled representation and guidance through negotiation, mediation, arbitration, and litigation processes. Whether resolving commercial disputes, contractual disagreements, or institutional conflicts, we provide strategic counsel to protect your interests and achieve effective, timely outcomes for individuals, companies, and organisations alike.`,
    },
  ];

  return (
    <section id="expertise" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-stone-900 mb-4">
            Areas of Expertise
          </h2>
          <p className="text-stone-600 font-light max-w-2xl mx-auto">
            Providing comprehensive legal services with dedication and professional excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {expertiseAreas.map((area, index) => (
            <div
              key={index}
              className="text-center bg-white p-8 rounded-lg shadow-sm border border-stone-200"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-stone-100 rounded-full">
                <i className={`${area.icon} text-3xl text-stone-700`}></i>
              </div>

              <h3 className="text-xl font-medium text-stone-900 mb-4">
                {area.title}
              </h3>

              <p className="text-stone-600 leading-relaxed font-light">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}